export const STR = {
  "greeting.returning_named": [
    "Welcome back, {name}!",
    "Hi again, {name} — good to see you!",
    "There you are, {name}! Welcome back.",
  ],
  "greeting.returning": [
    "Welcome back!",
    "Hi again — good to see you!",
    "Welcome back — let's eat.",
  ],

  "order.repeat_prompt": [
    "Want your usual today?",
    "Your usual today?",
    "Shall I grab your usual?",
  ],
  "order.start": ["Let's build your order."],

  "stations.none_open": [
    "Nothing's serving right now — check back in a little while.",
  ],
  "stations.only_one": [
    "{name}'s the only spot open right now, so I'll start your order there.",
  ],
  "stations.choose": ["Where are we ordering from today?"],
  "stations.substations": ["{stationName} has a few counters — which one?"],

  "options.loading": ["Pulling up the menu…"],
  "options.only_one": [
    "{name}'s the only option here, so I've got it selected for you.",
  ],
  "options.choose": ["What are you in the mood for?"],

  "group.only_item": [
    "{itemName} is the only {groupName} on the menu, so I've added it for you.",
  ],
  "group.choose_max": ["Pick your {groupName} — up to {max}:"],
  "group.choose": ["Pick your {groupName}:"],
  "group.nothing_else": ["That's everything in this group."],

  "allergy.ask": ["Any allergies I should know about?"],
  "allergy.instructions": ["Tap all that apply, then Done."],
  "allergy.saved": ["On file, you've told me you have this allergies: {list}."],
  "allergy.confirm": ["Still accurate?"],
  "allergy.none_safe": [
    "None of the {groupName} here are safe with your allergies.",
  ],
  "allergy.offer_show": [
    "If you'd like, I can show the ones that contain your allergens.",
  ],
  "allergy.toggle_show": ["Show {groupName} with my allergens"],
  "allergy.toggle_hide": ["Hide {groupName} with my allergens"],

  "name.first_ask": ["What's your first name?"],
  "name.first_onfile": ["I've got you as {name} — use that?"],
  "name.last_ask": ["And your last name?"],
  "name.last_onfile": ["Last name {name} — use that?"],

  "notify.ask": ["How should I let you know when it's ready?"],
  "notify.none": ["Hmm — no notification options available right now."],
  "notify.email_onfile": ["I've got {email} — use that?"],
  "notify.email_ask": ["What email should I use?"],
  "notify.phone_onfile": ["I've got {phone} — text that one?"],
  "notify.phone_ask": ["What number should I text?"],
  "notify.push_enabling": ["Setting up push notifications…"],
  "notify.telegram": ["Telegram's linked — I'll reach you there."],
  "notify.error_retry": ["{reason} Let's try another way to reach you."],

  "notes.ask": ["Anything special for the kitchen? (optional)"],

  "review.header": ["Here's what I've got for you:"],
  "submit.placing": ["Sending it to the kitchen…"],
  "submit.done_id": [
    "You're all set — order #{id} is in with the kitchen!",
    "Done! Order #{id} is in — I'll let you know when it's up.",
    "Order #{id} is in with the kitchen. You're all set!",
  ],
  "submit.done": [
    "You're all set — your order's in!",
    "Done! Your order's in with the kitchen.",
  ],

  "error.retry_or_restart": ["Give it another go, or start over."],
  "error.start_failed": [
    "Sorry — I couldn't get things started just now. Mind trying again?",
  ],

  "buttons.yes": ["Yes"],
  "buttons.start_fresh": ["Start fresh"],
  "buttons.update": ["Update"],
  "buttons.change": ["Change"],
  "buttons.done": ["Done"],
};

export const pick = (key) => {
  const arr = STR[key];
  if (!arr || arr.length === 0) return "";
  return arr[Math.floor(Math.random() * arr.length)];
};

export const line = (key) => (STR[key] ? STR[key][0] : "");

export const fill = (text, tokens) =>
  String(text).replace(/\{(\w+)\}/g, (m, k) =>
    tokens && tokens[k] != null ? tokens[k] : m,
  );

export const say = (key, tokens) => fill(pick(key), tokens);
